import { CurrencyPipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'euroCurrency'
})
export class EuroCurrencyPipe extends CurrencyPipe implements PipeTransform
{
    transform(value: any, currencyCode: string = 'EUR', display: 'symbol' | 'code' | 'name' | string = 'symbol', digitsInfo: string = '1.2-2'): any
    {
        const formattedValue = super.transform(value, currencyCode, display, digitsInfo);
        if (formattedValue)
        {
            let text = formattedValue.replace('€', '');
            text = text + '€';

            return text;
        }

        return formattedValue;
    }
}